<template>
  <Layout>
    <Content>
      <Breadcrumb :style="{margin: '5px 0'}">
        <BreadcrumbItem>支付管理 > <b>订单列表</b></BreadcrumbItem>
      </Breadcrumb>
      <Card >
            <span class="search_span_width">
                <span class="search_span_width_part1">支付状态：</span>
				 <Select v-model="search.pay_status" style="width:100px">
					 <Option value="0" :key="0">待支付</Option>
				        <Option value="2" :key="2">支付成功</Option>
						<Option value="1" :key="1">支付中</Option>
						<Option value="3" :key="3">支付失败</Option>
						<Option value="4" :key="4">已退款</Option>
				</Select>
            </span>
			<span class="search_span_width">
			    <span class="search_span_width_part1">用户类型：</span>
				 <Select v-model="search.user_type" style="width:100px">
					 <Option value="0" :key="0">用户</Option>
						<Option value="1" :key="1">代理商</Option>
				</Select>
			</span>
			<span class="search_span_width">
			    <span class="search_span_width_part1">订单号：</span>
				<Input v-model="search.order_no" placeholder="请输入订单号" style="width:160px" />
			</span>
			<span class="search_span_width">
			    <span class="search_span_width_part1">用户ID：</span>
				<Input v-model="search.user_id" placeholder="请输入用户ID" style="width:160px" />
			</span>
        <Button type='primary' icon="ios-search" :style="{'margin-left':'20px'}" @click="getOrderList()">搜索</Button>
      </Card>
      <Card>
        <Card id="tableContent" >
          <Table :columns="tableColumns" :data="order_list"></Table>
		  <Page :total="recordTotal" :current="page" :page-size="10" :show-elevator="true" @on-change="getOrderList"/>
		  
        </Card>
      </Card>
    </Content>

  </Layout>
</template>
<script>
export default {
  data(){
    return {
		search : {
			pay_status:-1,
			user_type:-1,
			order_no:'',
			user_id:''
		},
		showmodal:false,
		recordTotal:0,
		page:1,
		order_list:[],
		refundOrder:null,
		tableColumns:[
		{ title: '订单号', key: 'order_no', align: 'center',width:"230px" },
		{ title: '用户ID', key: 'user_id', align: 'center', width:"200px", render: (h, params) => {
				var txt = params.row.user_id;
				if (params.row.user_type =='0') {
					txt += '(用户)';
				} else if (params.row.user_type =='1') {
					txt += '(代理商)'+params.row.agent_name;
				}	
				return h("div",{},txt);
			}},
		{ title: '产品ID', key: 'product_id', align: 'center' },
		{ title: '产品名称', key: 'product_name', align: 'center' },
		{ title: '产品价格(元)', key: 'total_fee', align: 'center' },
		{ title: '创建时间', key: 'created_at', align: 'center',width:"180px" },
		{ title: '支付时间', key: 'time_end', align: 'center',width:"180px" },
		{ title: '支付状态', key: 'pay_status', align: 'center',
			render: (h, params) => {
				var txt = '';
				if (params.row.pay_status =='0') {
					txt = '待支付';
				} else if (params.row.pay_status =='1') {
					txt = '支付中';
				} else if (params.row.pay_status =='2') {
					txt = '支付成功';
				} else if (params.row.pay_status =='3') {
					txt = '支付失败';
				} else if (params.row.pay_status =='4') {
					txt = '已退款';
				}
				
				return h("div",{},txt);
			}
		},
		{ title: '操作', key: 'action', align: 'center', width:"120px",
			render: (h, params) => {
				if (params.row.pay_status == '2') {
					return h('Button', {
						props: {
							type: 'error',
							size: 'small'
						},
						on: {
							click: () => {
								this.showRefundConfirm(params.row);
							}
						}
					}, '退款');
				}
				return h('div', {}, '-');
			}
		}
		],
	}
  },
  mounted:function(){
    this.getOrderList();
  },
  computed:{
  },
  methods:{
	getOrderList(page = this.page) {
		this.page = page;
		let p = {'page' : page}
		let params = Object.assign(this.search, p);
		this.http.get('/admin/pay/orderList',{params:params}).then(response=>{
		  let data=response.data;
		  if(data.code!==0){
			alert(data.message);
		  } else{
			this.order_list = data.data.list;
			this.recordTotal = data.data.total;
		  }
		}).catch(()=>{
		  this.$Message.error('网络错误');
		});
	},
	handleRefund() {
		if (!this.refundOrder) return;
		this.http.post('/admin/pay/refund', {order_no: this.refundOrder.order_no}).then(response=>{
		  let data=response.data;
		  if(data.code!==0){
			this.$Message.error(data.message);
		  } else{
			this.$Message.success('退款成功');
			this.getOrderList();
		  }
		}).catch(()=>{
		  this.$Message.error('网络错误');
		});
	},
	showRefundConfirm(row) {
		this.refundOrder = row;
		this.$Modal.confirm({
			title: '确认退款',
			content: '确定要对该订单进行退款操作吗？',
			onOk: () => {
				this.handleRefund();
			}
		});
	}
  }
}
</script>
